/**
 * The one red mark on the screen (P90, Sarah 2026-10-20).
 *
 * *"Instead of being a full header with colour, just an alert symbol on
 * something that needs you."* So this is the ONLY place red is allowed — a
 * small warning triangle beside the row, account, entity or vendor that needs
 * attention. Never a banner, a fill, or a coloured row background; everything
 * else on a calm screen stays navy/white. See `.alert-sym` in styles.css.
 *
 * `title` makes it a labelled image for a screen reader and gives the hover
 * tooltip ("Below cash floor", "New vendor"); without one it is decorative,
 * because the row's own words already carry the meaning.
 */
export default function AlertSymbol({
  size = 15,
  title,
}: {
  size?: number;
  title?: string;
}) {
  return (
    <span
      className="alert-sym"
      title={title}
      role={title ? "img" : undefined}
      aria-label={title}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden={title ? undefined : true}
      >
        <path d="M8 2.6 14.4 13H1.6zM8 6.7v3M8 11.4h.01" />
      </svg>
    </span>
  );
}
